import {
    GET_TEMPLATE_DETAILS,
    GET_TEMPLATE_DETAILS_SUCCESS,
    GET_TEMPLATE_DETAILS_FAILURE,
} from 'src/pages/more/pages/templates/redux/action/actionTypes.js';

const initialState = {
    templateDetails: {
        loading: false,
        statusCode: 0,
        statusMessage: '',
    },
};

const templateDetailReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_TEMPLATE_DETAILS:
            return {
                ...state,
                templateDetails: {
                    loading: true,
                    statusCode: 0,
                    statusMessage: '',
                },
            };
        case GET_TEMPLATE_DETAILS_SUCCESS:
            return {
                ...state,
                templateDetails: {
                    ...state.templateDetails,
                    ...action.payload,
                    loading: false,
                },
                updateTemplate: {
                    loading: false,
                    statusCode: 0,
                    statusMessage: '',
                },
            };
        case GET_TEMPLATE_DETAILS_FAILURE:
            return {
                ...state,
                templateDetails: {
                    loading: false,
                    statusCode: action.statusCode,
                    statusMessage: action.statusMessage,
                },
                updateTemplate: {
                    loading: false,
                    statusCode: 0,
                    statusMessage: '',
                },
            };

        default: {
            return { ...state };
        }
    }
};

export default templateDetailReducer;
